




























































































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import PaystubReportView from "@/components/payroll/reports/paystub/PaystubReportView.vue";
import InvoiceDTO from "@/dto/InvoiceDTO";
import {ServiceRecordDTO} from "@/components/payroll/business/services/ServiceDTO";
import CompanyDTO from "@/dto/company/CompanyDTO";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import {Paystub} from "@/dto/payroll/PayrollDTO";
import PayrollService from "@/services/payroll/PayrollService";
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import ImportPayrollModal from "@/components/payroll/ImportPayrollModal.vue";
import {IEmployment} from "@/dto/payroll/IEmployment";
import GenerateInvoiceModal, {GenerateInvoiceForm} from "@/components/admin/imports/payroll/GenerateInvoiceModal.vue";
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import SimpleCompanySearch from "@/components/common/SimpleCompanySearch.vue";
import SublimeSearch from "@/components/common/SublimeSearch.vue";

export interface PayrollImportLog {
	id: number;
	company: CompanyDTO;
	importedFile: FileMetaDTO;
	createdBy: SublimeEmployeeDTO;
	payrolls: Paystub[];
	invoices: InvoiceDTO<ServiceRecordDTO>[];
	date: Date;
}

export interface EmploymentFilter {
	selectedEmploymentId: number | null;
}

export class PayrollImportLogFilter {
	companiesId: number[] = [];
	startDate: Date | null | string = null;
	endDate: Date | null | string = null
	assigneeId: number | null = null;
	page = 0;
	size = 10;

	constructor(init?: Partial<PayrollImportLogFilter>) {
		Object.assign(this, init)
	}
}

@Component({
	components: {
		FontAwesomeIcon,
		BTPortalCollapse,
		PaystubReportView,
		RightSideBar,
		SimpleCompanySearch,
		SublimeSearch
	}
})
export default class PayrollImport extends Vue {
	private payrollImports: Page<PayrollImportLog> = EMPTY_PAGE;
	private filter: PayrollImportLogFilter = new PayrollImportLogFilter();
	private employmentFilter: EmploymentFilter = {
		selectedEmploymentId: null
	};
	private selectedCompany: CompanyDTO | null = null;
	private showFilterSidebar = false;

	public created(): void {
		Application.startLoading()
			.then(this.loadPayrollImports)
			.finally(Application.stopLoading)
	}

	private loadPayrollImports(): Promise<void> {
		return PayrollService.getImportPageByFilter(this.filter).then(
			res => {
				this.payrollImports = res.data;
			},
			err => processError(err, this)
		)
	}

	private formatDate(date: Date | string): string {
		const dateObj = typeof date === 'string' ? new Date(date) : date;
		return new Intl.DateTimeFormat('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit'
		}).format(dateObj);
	}

	private formatCurrency(amount: number): string {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD'
		}).format(amount);
	}

	private formatPayPeriod(start: string, end: string): string {
		return `${start} - ${end}`;
	}

	private openImportModal(): void {
		this.$modal.show(
			ImportPayrollModal,
			{
				companyId: null,
				onSuccess: () => Application.startLoading()
					.then(() => this.$modal.hideAll())
					.then(this.loadPayrollImports)
					.finally(Application.stopLoading)
			}
		)
	}

	private filterPayrolls(): void {
	// 	this.filter.page = 0; // Reset page to 0 when filtering
	// 	Application.startLoading()
	// 		.then(this.loadPayrollImports)
	// 		.finally(Application.stopLoading)
		console.log("")
	}

	private clearEmploymentFilter(): void {
		this.employmentFilter.selectedEmploymentId = null;
		this.filterPayrolls();
	}

	private getUniqueEmployments(payrolls: Paystub[]): IEmployment[] {
		const uniqueEmployments = new Set<string>();
		const uniqueEmployees: IEmployment[] = [];

		payrolls.forEach(payroll => {
			if (payroll.employment && payroll.employment.id && !uniqueEmployments.has(payroll.employment.id.toString())) {
				uniqueEmployments.add(payroll.employment.id.toString());
				uniqueEmployees.push(payroll.employment);
			}
		});

		return uniqueEmployees;
	}

	private getFilteredPayrolls(payrolls: Paystub[]): Paystub[] {
		if (!this.employmentFilter.selectedEmploymentId) {
			return payrolls;
		}

		return payrolls.filter(payroll =>
			payroll.employment &&
			payroll.employment.id &&
			payroll.employment.id === this.employmentFilter.selectedEmploymentId
		);
	}

	private createInvoicesForImport(importItem: PayrollImportLog): void {
		this.$modal.show(
			GenerateInvoiceModal,
			{
				payrolls: importItem.payrolls,
				onConfirm: (form: GenerateInvoiceForm) => {
					Application.startLoading()
						.then(() => PayrollService.createInvoices({logId: importItem.id, payrolls: form.selectedPayrollIds, invoiceDate: form.invoiceDate}).then(
								() => Promise.resolve(),
								err => processError(err, this)
							)
						)
						.then(() => this.$modal.hideAll())
						.then(this.loadPayrollImports)
						.finally(Application.stopLoading)
				},
				onCancel: () => {
					this.$modal.hideAll();
				}
			},
			{
				width: '1200px'
			}
		)
	}

	private applyFilters(): void {
		this.filter.page = 0; // Reset page to 0 when applying filters
		if (this.selectedCompany) {
			this.filter.companiesId = [this.selectedCompany.id];
		}
		Application.startLoading()
			.then(this.loadPayrollImports)
			.finally(Application.stopLoading);
		this.showFilterSidebar = false;
	}

	private clearAllFilters(): void {
		this.filter = new PayrollImportLogFilter();
		this.employmentFilter.selectedEmploymentId = null;
		this.selectedCompany = null;
		Application.startLoading()
			.then(this.loadPayrollImports)
			.finally(Application.stopLoading);
		this.showFilterSidebar = false;
	}

	private onAssigneeChange(sublime: SublimeEmployeeDTO): void {
		this.filter.assigneeId = sublime.id;
	}

	get activeFiltersCount(): number {
		let count = 0;
		
		// Проверяем фильтр по компаниям
		if (this.filter.companiesId && this.filter.companiesId.length > 0) {
			count++;
		}
		
		// Проверяем фильтр по датам
		if (this.filter.startDate || this.filter.endDate) {
			count++;
		}
		
		// Проверяем фильтр по назначенному
		if (this.filter.assigneeId) {
			count++;
		}
		
		// Проверяем фильтр по размеру страницы (если не по умолчанию)
		if (this.filter.size !== 10) {
			count++;
		}

		return count;
	}
}
